"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.largeDesktopBreakingPoint = exports.midDesktopBreakingPoint = exports.desktopBreakingPoint = exports.tabletBreakingPoint = exports.mobileBreakingPoint = void 0;
exports.mobileBreakingPoint = 320;
exports.tabletBreakingPoint = 599;
exports.desktopBreakingPoint = 960;
exports.midDesktopBreakingPoint = 1280;
exports.largeDesktopBreakingPoint = 1920;
